<template>
	<div style="width: 1650px;">
		<Tabs type="card">
			<TabPane label="分发数据监控">
				<DistributeDataMonitor ref="DistributeDataMonitor"></DistributeDataMonitor>
			</TabPane>
			<TabPane label="线下数据监控">
				
			</TabPane>
		</Tabs>
	</div>

</template>

<script>
	import DistributeDataMonitor from './components/DistributeDataMonitor.vue';
	import {
		mapActions,
		mapGetters
	} from "vuex";
	export default {
		name: "loan_management",

		components: {
			DistributeDataMonitor
		},
	}
</script>

<style>
</style>
